<app-tab-carousel
    [id]="id"
    [components]="featureComponents"
    [featureComponents]="featureComponents"
    [activeFeature]="activeFeature">
</app-tab-carousel>